import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as studentAPI from "../../api/student";

const initialState = {
  data: {},
  activeStudent: null,
  studentPersonalInfo: {},
  activeProfileImage: null,
  program: null,
  educationInformation: [
    {
      id: "",
      idStudent: null,
      type: null,
      course: null,
      year: null,
      aggregate: null,
      address: null,
      universityOrBboard: null,
      collegeOrSchool: null,
    },
  ],
  parentalInfo: [
    {
      id: "",
      idStudent: null,
      type: null,
      mobile: null,
      address: null,
      job: null,
      jobAddress: null,
      name: null,
    },
  ],
  achievementsList: [
    {
      id: "",
      idStudent: null,
      type: null,
      level: null,
      awardName: null,
      awardYear: null,
    },
  ],
  extraCurricularActivityList: [
    {
      id: "",
      idStudent: null,
      name: null,
      description: null,
    },
  ],
  interestList: [],
  status: null,
  profileCompleteness: 0,
  loading: false,
  perPage: 10,
  page: 1,
  offset: 0,
};

const searchStudentAction = createAsyncThunk(
  "student/searchStudent",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.searchStudent(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data?.body;
    } catch (error) {
      console.error("error", error);
      rejectWithValue(error);
    }
  }
);

const addStudentInfo = createAsyncThunk(
  "student/personal",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.studentPersonal(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateStudentProfile = createAsyncThunk(
  "student/update/personal",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.updateStudentProfile(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return { res: res.data, params: params };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const studentEducation = createAsyncThunk(
  "student/education",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.studentEducation(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addStudentContacts = createAsyncThunk(
  "student/contact",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.addStudentContacts(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addAchievements = createAsyncThunk(
  "student/achievement",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.addAchievements(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addExtraCurricularActivities = createAsyncThunk(
  "student/extracurricular",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.addExtraCurricularActivities(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addInterests = createAsyncThunk(
  "student/interest",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.addInterests(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStudentInfo = createAsyncThunk(
  "student/delete",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.deleteStudentInfo(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStudentEducation = createAsyncThunk(
  "s/delete/student/edu",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.deleteStudentEducation(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStudentContacts = createAsyncThunk(
  "s/delete/student/contacts",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.deleteStudentContacts(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStudentAchievements = createAsyncThunk(
  "s/delete/student/achievements",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.deleteStudentAchievements(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteStudentExtraCurricular = createAsyncThunk(
  "s/delete/student/extracurricular",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.deleteStudentExtraCurricular(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentInfo = createAsyncThunk(
  "student/getStudent",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.getStudentInfo(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const uploadProfilePic = createAsyncThunk(
  "student/uploadprofile",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.uploadProfilePic(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getProgram = createAsyncThunk(
  "student/getProgram",
  async (params, { rejectWithValue }) => {
    try {
      const res = await studentAPI.getProgram(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const studentSlice = createSlice({
  name: "student",
  initialState: initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setActiveStudent: (state, action) => {
      state.activeStudent = action.payload;
    },
    setPersonalInfo: (state, action) => {
      return {
        ...state,
        studentPersonalInfo: {
          ...state.studentPersonalInfo,
          ...action.payload,
        },
      };
    },
    resetStudentPersonalInfo: (state) => {
      state.studentPersonalInfo = initialState.studentPersonalInfo;
      state.educationInformation = initialState.educationInformation;
      state.achievementsList = initialState.achievementsList;
      state.extraCurricularActivityList =
        initialState.extraCurricularActivityList;
      state.parentalInfo = initialState.parentalInfo;
      state.interestList = initialState.interestList;
      state.activeStudent = initialState.activeStudent;
    },
    addEducation: (state) => {
      let params = {
        id: "",
        idStudent: null,
        type: null,
        course: null,
        year: null,
        aggregate: null,
        address: null,
        universityOrBboard: null,
        collegeOrSchool: null,
      };
      state.educationInformation = [...state.educationInformation, params];
    },
    addParentalInfo: (state) => {
      let params = {
        id: "",
        idStudent: null,
        type: null,
        mobile: null,
        address: null,
        job: null,
        jobAddress: null,
      };
      state.parentalInfo = [...state.parentalInfo, params];
    },
    addAchievement: (state) => {
      let params = {
        id: "",
        idStudent: null,
        type: null,
        level: null,
        awardName: null,
        awardYear: null,
      };
      state.achievementsList = [...state.achievementsList, params];
    },
    addExtraCurricularActivity: (state) => {
      let params = {
        id: "",
        idStudent: null,
        name: null,
        description: null,
      };
      state.extraCurricularActivityList = [
        ...state.extraCurricularActivityList,
        params,
      ];
    },
    addInterestList: (state, action) => {
      const interestList = action.payload.checked.map((_el, index) => {
        return {
          id: "",
          idStudent: current(state).studentPersonalInfo?.id,
          name: _el,
          description: _el,
        };
      });
      state.interestList = interestList;
    },
    updateEductionInfoItemData: (state, action) => {
      const { type, index, data } = action.payload;
      state.educationInformation[index][type] = data;
      if (state.studentPersonalInfo.id) {
        state.educationInformation[index]["idStudent"] =
          state.studentPersonalInfo.id;
      } else {
        state.educationInformation[index]["idStudent"] = state.activeStudent;
      }
    },
    updateParentalInfoData: (state, action) => {
      const { type, index, data } = action.payload;
      state.parentalInfo[index][type] = data;
      if (current(state).studentPersonalInfo.id) {
        state.parentalInfo[index]["idStudent"] =
          current(state).studentPersonalInfo.id;
      } else {
        state.parentalInfo[index]["idStudent"] = current(state).activeStudent;
      }
    },
    updateAchievement: (state, action) => {
      const { type, index, data } = action.payload;
      state.achievementsList[index][type] = data;
      if (current(state).studentPersonalInfo.id) {
        state.achievementsList[index]["idStudent"] =
          current(state).studentPersonalInfo.id;
      } else {
        state.achievementsList[index]["idStudent"] =
          current(state).activeStudent;
      }
    },
    updateExtraCurricularActivity: (state, action) => {
      const { type, index, data } = action.payload;
      state.extraCurricularActivityList[index][type] = data;
      if (current(state).studentPersonalInfo.id) {
        state.extraCurricularActivityList[index]["idStudent"] =
          current(state).studentPersonalInfo.id;
      } else {
        state.extraCurricularActivityList[index]["idStudent"] =
          current(state).activeStudent;
      }
    },
    setPictureUrl: (state, action) => {
      state.activeProfileImage = action.payload;
    },

    removeEducation: (state, action) => {
      state.educationInformation = state.educationInformation.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    removeParentalInfo: (state, action) => {
      state.parentalInfo = state.parentalInfo.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    removeAchievement: (state, action) => {
      state.achievementsList = state.achievementsList.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    removeExtraCurricularActivity: (state, action) => {
      state.extraCurricularActivityList =
        state.extraCurricularActivityList.filter(
          (_el, index) => index !== action.payload.key
        );
    },
    removeInterestList: (state, action) => {
      state.interestList = state.interestList.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    updateStudentPersonalInfo: (state) => {
      return { ...state, studentPersonalInfo: updateParentalInfoData[0] };
    },
    resetProfileCompleteness: (state) => {
      state.profileCompleteness = 0;
    },
    setProfileCompleteness: (state) => {
      if (JSON.stringify(state.studentPersonalInfo) !== "{}") {
        state.profileCompleteness = 20;
      }
      if (
        state.educationInformation?.length > 0 &&
        state.educationInformation?.[0]?.idStudent?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state.parentalInfo?.length > 0 &&
        state.parentalInfo?.[0]?.idStudent?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state.achievementsList?.length > 0 &&
        state.achievementsList?.[0]?.idStudent?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state.extraCurricularActivityList?.length > 0 &&
        state.extraCurricularActivityList?.[0]?.idStudent?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state.interestList?.length > 0 &&
        state.interestList?.[0]?.idStudent?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
    },
  },
  extraReducers: {
    [searchStudentAction.pending]: (state) => {
      state.loading = true;
    },
    [searchStudentAction.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [searchStudentAction.rejected]: (state) => {
      state.loading = false;
    },

    [addStudentInfo.pending]: (state) => {
      state.loading = true;
    },
    [addStudentInfo.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentPersonalInfo = action?.payload?.body?.studentDetails;
      toast.success(action?.payload?.body?.success);
    },
    [addStudentInfo.rejected]: (state, action) => {
      state.loading = false;
      toast.error(action.payload);
    },

    [updateStudentProfile.pending]: (state) => {
      state.loading = true;
    },
    [updateStudentProfile.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.res.body);
    },
    [updateStudentProfile.rejected]: (state) => {
      state.loading = false;
    },

    [studentEducation.pending]: (state) => {
      state.loading = true;
    },
    [studentEducation.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.body);
    },
    [studentEducation.rejected]: (state) => {
      state.loading = false;
    },

    [addStudentContacts.pending]: (state) => {
      state.loading = true;
    },
    [addStudentContacts.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.body);
    },
    [addStudentContacts.rejected]: (state) => {
      state.loading = false;
    },

    [addAchievements.pending]: (state) => {
      state.loading = true;
    },
    [addAchievements.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.body);
    },
    [addAchievements.rejected]: (state) => {
      state.loading = false;
    },

    [addExtraCurricularActivities.pending]: (state) => {
      state.loading = true;
    },
    [addExtraCurricularActivities.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [addExtraCurricularActivities.rejected]: (state) => {
      state.loading = false;
    },

    [addInterests.pending]: (state) => {
      state.loading = true;
    },
    [addInterests.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload.body);
    },
    [addInterests.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentInfo.pending]: (state) => {
      state.loading = true;
      state.profileCompleteness = 0;
    },
    [getStudentInfo.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentPersonalInfo = action.payload.studentPersonalInfo;
      if (action.payload.educationList.length > 0) {
        state.educationInformation = action.payload.educationList;
      } else {
        state.educationInformation = initialState.educationInformation;
      }
      if (action.payload.contactsList.length > 0) {
        state.parentalInfo = action.payload.contactsList;
      } else {
        state.parentalInfo = initialState.parentalInfo;
      }
      if (action.payload.achievementsList.length > 0) {
        state.achievementsList = action.payload.achievementsList;
      } else {
        state.achievementsList = initialState.achievementsList;
      }
      if (action.payload.extraCurricularActivityList.length > 0) {
        state.extraCurricularActivityList =
          action.payload.extraCurricularActivityList;
      } else {
        state.extraCurricularActivityList =
          initialState.extraCurricularActivityList;
      }
      if (action.payload.interestList.length > 0) {
        state.interestList = action.payload.interestList;
      } else {
        state.interestList = initialState.interestList;
      }
    },
    [getStudentInfo.rejected]: (state) => {
      state.loading = false;
    },

    [deleteStudentInfo.pending]: (state) => {
      state.loading = true;
    },
    [deleteStudentInfo.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStudentInfo.rejected]: (state) => {
      state.loading = false;
    },
    [deleteStudentEducation.pending]: (state) => {
      state.loading = true;
    },
    [deleteStudentEducation.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStudentEducation.rejected]: (state) => {
      state.loading = false;
    },
    [deleteStudentContacts.pending]: (state) => {
      state.loading = true;
    },
    [deleteStudentContacts.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStudentContacts.rejected]: (state) => {
      state.loading = false;
    },
    [deleteStudentAchievements.pending]: (state) => {
      state.loading = true;
    },
    [deleteStudentAchievements.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStudentAchievements.rejected]: (state) => {
      state.loading = false;
    },
    [deleteStudentExtraCurricular.pending]: (state) => {
      state.loading = true;
    },
    [deleteStudentExtraCurricular.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteStudentExtraCurricular.rejected]: (state) => {
      state.loading = false;
    },
    [uploadProfilePic.pending]: (state) => {
      state.loading = true;
    },
    [uploadProfilePic.fulfilled]: (state,action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [uploadProfilePic.rejected]: (state) => {
      state.loading = false;
    },

    [getProgram.pending]: (state) => {
      state.loading = true;
    },
    [getProgram.fulfilled]: (state, action) => {
      state.loading = false;
      state.program = action.payload;
    },
    [getProgram.rejected]: (state) => {
      state.loading = false;
      state.program = [];
    },
  },
});

const {
  resetState,
  addEducation,
  removeEducation,
  addParentalInfo,
  updateEductionInfoItemData,
  resetStudentPersonalInfo,
  updateAchievement,
  removeParentalInfo,
  updateExtraCurricularActivity,
  updateParentalInfoData,
  addAchievement,
  addExtraCurricularActivity,
  addInterestList,
  removeAchievement,
  removeExtraCurricularActivity,
  removeInterestList,
  updateStudentPersonalInfo,
  setActiveStudent,
  setProfileCompleteness,
  resetProfileCompleteness,
  setPictureUrl,
  setPersonalInfo,
  setPerPage,
  setOffset,
  setPage,
} = studentSlice.actions;
export default studentSlice.reducer;
export {
  resetState,
  searchStudentAction,
  addStudentInfo,
  addEducation,
  removeEducation,
  addParentalInfo,
  updateEductionInfoItemData,
  studentEducation,
  resetStudentPersonalInfo,
  updateAchievement,
  updateExtraCurricularActivity,
  deleteStudentInfo,
  deleteStudentEducation,
  deleteStudentContacts,
  deleteStudentAchievements,
  deleteStudentExtraCurricular,
  removeParentalInfo,
  updateParentalInfoData,
  addStudentContacts,
  addAchievement,
  addExtraCurricularActivity,
  addInterestList,
  removeAchievement,
  removeExtraCurricularActivity,
  removeInterestList,
  addAchievements,
  addExtraCurricularActivities,
  addInterests,
  updateStudentPersonalInfo,
  getStudentInfo,
  updateStudentProfile,
  setActiveStudent,
  uploadProfilePic,
  setProfileCompleteness,
  resetProfileCompleteness,
  setPictureUrl,
  setPersonalInfo,
  getProgram,
  setPerPage,
  setOffset,
  setPage,
};
